import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PlatformsDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoverIndex, setHoverIndex] = useState(null);

  const sections = [
    { title: "Connected Mobility", slug: "connected-mobility", bg: "#9CABBD" },
    { title: "Sage AI", slug: "sage-ai", bg: "#88C4A0" },
    { title: "Agents of Mobility", slug: "agents-of-mobility", bg: "#F7C5D9" },
  ];

  const defaultBg = "#ECEAEB";
  const currentPlatformName = decodeURIComponent(location.pathname.replace("/platform/", ""));
  const isMobile = window.innerWidth < 1024;

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "1rem",
        boxShadow: "0px 4px 4px 0px rgba(249, 245, 245, 0.25)",
        zIndex: "9999",
      }}
    >
      <div style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
        gap: isMobile ? "0" : "1rem",
      }}>
        {sections.map((item, idx) => {
          const isActive = currentPlatformName === item.slug;
          const isHovered = hoverIndex === idx;
          const bgColor = isHovered ? "#D2D2D2" : isActive ? item.bg : defaultBg;

          return (
            <div
              key={idx}
              style={{
                backgroundColor: isMobile ? "none" : bgColor,
                padding: "16px",
                borderRadius: isMobile ? "0" : "6px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                height: window.innerWidth < 1024 ? "80px" : "75px",
                boxShadow: !isMobile && (isHovered || isActive ? "0 4px 12px rgba(0,0,0,0.12)" : "none"),
                borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
              }}
              onClick={() => navigate(`/platform/${item.slug}`)}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: isMobile ? "34px" : "18px",
                  marginBottom: !isMobile ? "0.4rem" : 0,
                  color: isMobile && isActive ? "#F00D69" : "#111827", 
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{item.title}</span>
                <img
                  src="/assets/fonts/icons/RightIcon.png"
                  alt="arrow"
                  style={{ width: "6px", height: "8px", marginLeft: "10px", fontSize: "18px", }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlatformsDropdown;